import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private loginState = new BehaviorSubject<boolean>(this.hasToken());
    loginState$ = this.loginState.asObservable();

    constructor() { }

    hasToken(): boolean {
        return !!localStorage.getItem('token');
    }

    setLoggedIn() {
        this.loginState.next(true);
    }

    setLoggedOut() {
        this.loginState.next(false);
    }

    addKey(key: string, value: any) {
        let p = localStorage.getItem(key);
        if (p != null) {
            localStorage.removeItem(key);
            localStorage.setItem(key, JSON.stringify(value));
        }
        else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }
    
    getKey(key: string) {
        let p = localStorage.getItem(key);
        if (p != null) {
            return JSON.parse(p);
        }
        return null;
    }

    removeKey(key: string) {
        localStorage.removeItem(key);
    }
}
